import React from "react";
import Icon from "components/icon";

function Landing() {
  return (
    <div className="landing">
      <div>
        <h1>Loyalty</h1>
        <a href="/b/swipely-bistro">Swipely Bistro</a>
        <h1>Online Ordering</h1>
        <a href="/s/breadcrumb-test-account-providence">
          Breadcrumb Test Account Providence
        </a>
        <h1>Mobile Pay</h1>
        <a href="/s/breadcrumb-test-account-providence/pay?testmobilepay">
          Breadcrumb Test Account Providence
        </a>
        <h1>Digital Gift Card</h1>
        <a href="/b/upserve-lounge/gift-card">Upserve Lounge</a>
      </div>
      <Icon className="ghost" type="receipt-ghost" />
    </div>
  );
}

export default Landing;
